import { DropdownIcon } from '@snapi/icons';
import { motion } from 'framer-motion';

interface CaretToggleProps {
  open: boolean;
}

export const CaretToggle = ({ open }: CaretToggleProps) => (
  <motion.span
    animate={open ? 'open' : 'closed'}
    variants={{
      open: { rotate: 180 },
      closed: { rotate: 0 },
    }}
    transition={{ duration: 0.5 }}
    className="flex h-5 w-5 justify-center items-center"
  >
    <DropdownIcon />
  </motion.span>
);
